/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import { Button as NativeButton } from '@mantine/core';
import classes from './Button.module.css';

export const Button = (props: {
	id?: string;
	onClick?: () => void;
	children?: ReactNode;
	size?: string;
	variant?: string;
	color?: string;
	fullWidth?: boolean;
	loading?: boolean;
	disabled?: boolean;
	leftSection?: ReactNode;
	visibleFrom?: string;
	hiddenFrom?: string;
	compact?: boolean;
	type?: any;
	readOnly?: boolean;
}) => {
	return (
		<NativeButton classNames={classes} {...props}>
			{props.children}
		</NativeButton>
	);
};
